const getEstimateUrl = (configId: string, withForm: boolean = true) =>
  `${window.location.origin}${
    window.location.pathname
  }#/estimate?id=${configId}${withForm ? '' : '&noForm=1'}`;

export default getEstimateUrl;
